import {
  allEthnicities,
  ETHNICITY_REGIONS,
  ethnicityRegion
} from 'src/components/questionnaire/Constants';

export function mergeEthnicityRows(custom) {
  const overrides = new Map(
    (Array.isArray(custom) ? custom : []).map((e) => [e.name, e])
  );

  return allEthnicities.map((name) => {
    const override = overrides.get(name);
    return {
      name,
      show: override?.show ?? true,
      topOfList: override?.topOfList ?? false,
      region: ethnicityRegion(name)
    };
  });
}

export function resolveEthnicityOptions(custom) {
  if (!Array.isArray(custom) || custom.length === 0) return allEthnicities;

  const visible = mergeEthnicityRows(custom).filter((e) => e.show);

  const byName = (a, b) => a.name.localeCompare(b.name);
  const top = visible.filter((e) => e.topOfList).sort(byName);
  const rest = visible.filter((e) => !e.topOfList).sort(byName);

  return [...top, ...rest].map((e) => e.name);
}

export function readEthnicitySettings(responseData) {
  if (Array.isArray(responseData)) return responseData; // defensive
  return responseData?.ethnicity || [];
}

export function deriveEthnicityBulkState(inScope) {
  const rows = Array.isArray(inScope) ? inScope : [];
  const total = rows.length;
  const shown = rows.filter((e) => e.show).length;
  const hidden = total - shown;
  const pinned = rows.filter((e) => e.topOfList).length;

  return {
    total,
    shown,
    hidden,
    pinned,
    visibility:
      total > 0 && hidden === 0
        ? { action: 'hide', patch: { show: false }, count: total }
        : { action: 'show', patch: { show: true }, count: hidden },
    pin:
      pinned === 0
        ? { action: 'pin', patch: { topOfList: true }, count: total }
        : { action: 'unpin', patch: { topOfList: false }, count: pinned }
  };
}

export { ETHNICITY_REGIONS, ethnicityRegion, allEthnicities };
